let stripe = window.Stripe('pk_live_51I6pp6BYoIZXSFfEaElayM7HwaMl9hdDWQ2LJMFFs4HqBFWEDTZaw6BcHjDAwaNhuq28epXPUZGE18dmVo9YUQrw00fyw3aeGb');
if (window.location.hostname == 'localhost') {
  stripe = window.Stripe('pk_test_51I6pp6BYoIZXSFfEtzo7gnPOesx59yrBBrFFpg23zfi9XP4r5cAuiY4BwkgWifg8f6eS6IsVXHDZDD8K3rmAq99Z00Y37J6EXl');
}

export default stripe;